import { create } from "zustand";

/**
 * useCadastroAprovadoresListaFilters
 */

type State = {
  nomeEmailFuncionario: string | null;
  centrosCustos: number[] | null;
};

export const initialCadastroAprovadoresLista = {
  nomeEmailFuncionario: null,
  centrosCustos: null,
}

export const useCadastroAprovadoresListaFilters = create<State>((set) => ({
  ...initialCadastroAprovadoresLista,
}));